import React, { memo } from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import { CommonProperties, CommonStyles, Color } from '../../styles';
import AnimatedEllipsis from '../AnimatedEllipsis';
import Icon from '../Icon';
import { scale } from '../../utils/scale.utils';
import BaseText from '../BaseText';
import ListControl from './ListControl';

const BarItem = ({ selected, label, loading, disabled, second, icon, primary, ...rest }) => {
  const selectedStyled = selected ? styles.barTextSelected : styles.barText;
  const selectedColor = disabled ? styles.disabled : null;
  return (
    <TouchableOpacity
      disabled={disabled}
      style={[styles.barSegmented, selected && styles.barSelected]}
      {...rest}
    >
      <View style={CommonStyles.centerItems}>
        {loading ? (
          <AnimatedEllipsis />
        ) : icon ? (
          <Icon
            name={icon}
            style={[CommonStyles.mb2, selectedStyled]}
            size={24}
            color={!disabled && primary ? Color.primary : Color.disabled}
          />
        ) : (
          <BaseText style={[CommonStyles.h2, selectedStyled]}>{label}</BaseText>
        )}
        <BaseText
          numberOfLines={1}
          style={[
            styles.barSecondText,
            selectedStyled,
            primary && styles.barTextPrimary,
            selectedColor,
          ]}
        >
          {second}
        </BaseText>
      </View>
    </TouchableOpacity>
  );
};

const TabBar = memo(({ items = [], selected, onChange, loading, style, primary }) => {
  return (
    <ListControl
      items={items}
      style={[styles.definedHeight, style]}
      renderItem={(item) => (
        <BarItem
          icon={item.icon}
          label={item.label}
          disabled={item.disabled}
          second={item.second}
          primary={primary}
          loading={loading}
          selected={selected && item.value === selected}
          onPress={() => onChange(item.value)}
        />
      )}
    />
  );
});

const styles = StyleSheet.create({
  barSegmented: {
    flex: 1,
    borderTopWidth: 4,
    borderTopColor: 'white',
    flexShrink: 1,
    height: '100%',
    justifyContent: 'center',
  },
  barText: {
    color: '#a1a1a1',
  },
  barSecondText: {
    marginTop: -6,
    textAlignVertical: 'top',
    ...CommonProperties.h4,
  },
  barTextSelected: {
    color: Color.active,
  },
  barSelected: {
    borderTopColor: Color.active,
  },
  barTextPrimary: {
    color: Color.primary,
  },
  disabled: {
    color: Color.disabled,
  },
  definedHeight: {
    height: scale(60),
    ...CommonProperties.centerAlignment,
  },
});

export default TabBar;
